<div class="container-div">
  @if (loader) {
  <div class="spinner-container">
    @if (loader) {
    <mat-spinner class="mat-spinner"></mat-spinner>
    }
  </div>
  }

  <cds-tile class="headers" id="headers">
    <div>
      @if (dealerLogoDetails?.url && !showBackButton) {
        <div class="header-inc-logo">
          <img id="inc-logo-image" [src]="dealerLogoDetails?.url" alt="">
        </div>
      }
    
      @if (showBackButton) {
        <button mat-button (click)="goBack()" class="back-button"
                [style.visibility]="showBackButton ? 'visible' : 'hidden'">
          <img src="../../assets/common/back-icon.png" alt="Back" width="24" height="24" />
        </button>
      }
    </div>
    
    <div class="icons">
      <div class="language-icon-with-text">
        <p class="Langtext">{{currentLanguage}}</p>
        <img #language src="./../../assets/common/translate.svg" alt="File not found." i18n-alt class="langIcon"
          mat-button [matMenuTriggerFor]="menu">

        <mat-menu #menu="matMenu">
          @for (i of languageConfiguration.Langauges; track i) {
          <div>
            <button mat-menu-item (click)="changeLanguage(i.LanguageFileName)"> <img src="{{i.SvgFlagAddress}}"
                style="border-radius: 50%; width: 30px; height: 30px;" alt="{{i.SvgFlagAddress}}">
              {{i.LanguageToShowInMenu}}</button>
          </div>
          }
        </mat-menu>
      </div>


      @if (showDownloadIcon) {
      <div class="download-icon">
        <img src="./../../assets/common/download-tray.svg" alt="File not found." i18n-alt mat-mini-fab color="primary"
          (click)="downloadPDF()">
      </div>
      }
      @if (showHomeIcon) {
      <div #navigation class="home-icon">
        <img src="./../../assets/common/home.svg" alt="File not found." i18n-alt mat-button
          [routerLink]="['/', 'vhc-report']" [queryParams]="{token: token}">
      </div>
      }
    </div>
  </cds-tile>
  <router-outlet class="component-div"></router-outlet>
</div>